import { render, staticRenderFns } from "./VisitorsList.vue?vue&type=template&id=2f41bdf3&"
import script from "./VisitorsList.vue?vue&type=script&lang=js&"
export * from "./VisitorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f41bdf3')) {
      api.createRecord('2f41bdf3', component.options)
    } else {
      api.reload('2f41bdf3', component.options)
    }
    module.hot.accept("./VisitorsList.vue?vue&type=template&id=2f41bdf3&", function () {
      api.rerender('2f41bdf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Stats/Metrics/VisitorsList.vue"
export default component.exports